module.exports = __webpack_public_path__ + "img/40_38_034_530.2b606296.jpg";